import React, {useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import {ContainerHeader} from "../../module";
import {useDispatch} from "react-redux";
import Dropzone from 'react-dropzone';
import TextField from "@mui/material/TextField";
import Button from '@mui/material/Button';
import Paper from "@mui/material/Paper";
import "./Slide_images.css";
import {deleteProduct} from "../../../stores/product/thunks";
import ModalAlerterCallback from "../../utils/ModalAlerterCallback";
import {
    deleteSlideImage,
    editSlideImage,
    getSliderById,
    getSliderImages,
    registerSlideImage
} from "../../../stores/slider/thunk";
import {useHistory, useParams} from 'react-router';

export default function SlideImages(){

    const dispatch = useDispatch();
    const history = useHistory();
    const {id} = useParams()
    let [sliders, setSliders] = useState([]);
    const [idSliderForDelete, setIdSliderForDelete] = useState(null);


    function removeProduct(id, store) {
        const callback = () =>{
            if(store){
                dispatch(deleteSlideImage(id, ()=> setSliders(sliders.filter((e) => e.id !== id))))
            } else setSliders(sliders.filter((e) => e.id !== id));
        }

        ModalAlerterCallback(callback);
        // dispatch(deleteCoursesAdmin({ course_id }));
    }

    function addSlider(data) {
        setSliders(prevState => ([...prevState,
            {
                id: (data + 1) * sliders.length,
                store: false,
                attributes: [
                    {
                        name: "name",
                        label: "عنوان اسلایدر",
                        value: ""
                    },
                    {
                        name: "priority",
                        label: "اولویت",
                        value: ""
                    },
                    {
                        name: "link",
                        label: "لینک",
                        value: ""
                    },
                    {
                        name: "image",
                        label: "",
                        value: "",
                        valueOfBack: null
                    },
                ]
            }
        ]))
        ;
    }

    function checkForEdit(value, valueOfBack) {
        if (valueOfBack === null) {
            return value
        } else {
            if (value === valueOfBack) {
                return ""
            } else return value
        }
    }

    async function registerSlider(sliderId) {
        let attribute = sliders.filter(x => x.id === sliderId)[0].attributes;
        const dataTable = {
            slider_id: id,
            // slider_id: props.location.state.id,
            title: attribute[0].value,
            priority: attribute[1].value,
            // image_priority: "",
            link: attribute[2].value,
            image: attribute[3].value
        };

        const formData = new FormData();
        for (let keyName in dataTable) {
            if (dataTable[keyName] !== "") {
                formData.append(keyName, dataTable[keyName]);
            }
        }
        dispatch(registerSlideImage(formData))
        // await axios({
        //     method: "post",
        //     url: strings.baseUrl + `slider-image`,
        //     data: formData,
        //     headers: {
        //         "content-type": "multipart/form-data",
        //         "Authorization": `Bearer ${mToken}`
        //     }
        // })
        //     .then(result => {
        //         if (result.data.status_code === 200) {
        //             handleClick("success", "خوش آمدید", <h3>با موفقیت اضافه شد</h3>, false);
        //             setSliders([]);
        //             getAllSlide()
        //         }else if(result.data.status_code === 401){
        //             dispatch({type: "SET_ADMIN_TOKEN", data: ""})
        //         }
        //     })
        //     .catch(() => {
        //         handleClick("success", "خوش آمدید", <h3>خطایی رخ داد</h3>, false)
        //     })
    }

    async function EditSlider(slideId) {
        let attribute = sliders.filter(x => x.id === slideId)[0].attributes;
        const dataTable = {
            slider_image: slideId,
            slider_id: id,
            title: attribute[0].value,
            priority: attribute[1].value,
            // image_priority: "",
            link: attribute[2].value,
            image: checkForEdit(attribute[3].value, attribute[3].valueOfBack)
        };

        const formData = new FormData();
        for (let keyName in dataTable) {
            if (dataTable[keyName] !== "" && dataTable[keyName] !== null) {
                formData.append(keyName, dataTable[keyName]);
            }
        }
        dispatch(editSlideImage(slideId, formData))
        // await axios({
        //     method: 'post',
        //     url: strings.baseUrl + `slider-image/${id}`,
        //     data: formData,
        //     headers: {
        //         "Authorization": `Bearer ${mToken}`
        //     }
        // })
        //     .then(result => {
        //         if (result.data.status_code === 200) {
        //             handleClick("success", "خوش آمدید", <h3>با موفقیت ویرایش شد</h3>, false);
        //             setSliders([]);
        //             getAllSlide()
        //         }else if(result.data.status_code === 401){
        //             dispatch({type: "SET_ADMIN_TOKEN", data: ""})
        //         } else handleClick("success", "خوش آمدید", <h3>خطایی رخ داد</h3>, false)
        //     })
        //     .catch(() => {
        //         handleClick("success", "خوش آمدید", <h3>خطایی رخ داد</h3>, false)
        //     })
    }

    function setParameters(e, id) {
        const {name, value} = e.target;
        let newArr = [...sliders];
        newArr.filter(x => x.id === id)[0].attributes.filter(x => x.name === name)[0].value = value;
        setSliders(newArr)
    }

    function Determination(item) {
        const type = typeof item;
        if (type === "object") {
            return <img src={URL.createObjectURL(item)} alt=""/>
        } else return <img src={item} alt=""/>
    }

    function onDrop(acceptedFiles, id) {
        let newArr = [...sliders];
        acceptedFiles.map(file => {
            return newArr.filter(x => x.id === id)[0].attributes.filter(x => x.name === `image`)[0].value = file
        });
        setSliders(newArr)
    }

    const callback = (res) => {
        res.images.forEach(item => {
            setSliders(prevState => ([...prevState,
                {
                    id: item.id,
                    store: true,
                    attributes: [
                        {
                            name: "name",
                            label: "عنوان اسلایدر",
                            value: item.title
                        },
                        {
                            name: "priority",
                            label: "اولویت",
                            value: item.priority
                        },
                        {
                            name: "link",
                            label: "لینک",
                            value: item.link
                        },
                        {
                            name: "image",
                            label: "",
                            value: item.image_name,
                            valueOfBack: item.image_name
                        },
                    ]
                }
            ]))
        })
    }

    useEffect(()=>{
        dispatch(getSliderImages(id, callback))
    },[])

    function redirectSliders() {
        history.push('/sliders');
    }

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">

            <ContainerHeader
                data={{
                    filter: false,
                    addBtn: true,
                }}
                headerTitle="مدیریت اسلاید ها"
                titleBtn="بازگشت"
                addBtnAction={redirectSliders}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper>
                {sliders.length > 0 && sliders.map((data, i) => {
                    return <div className="d-flex flex-column px-4 mt-3 position-relative" key={i}>
                        <div className="divParentTitleBasicInformation">
                            <h3>{data.attributes[0].value}</h3>
                            <hr className="w-100"/>
                            <i
                                // onClick={() => {
                                //     setOpen(!open)
                                // }}
                                className="fas fa-chevron-down"
                                // style={{transform: open ? "rotate(180deg)" : ""}}
                            />
                        </div>
                        <div className="d-flex flex-wrap position-relative">
                            {data.attributes && data.attributes.map((res, i) => (
                                res.name === "image" ?
                                    <Grid item key={i}
                                          lg={8} xl={8}
                                          className="d-flex justify-content-center align-items-center parentBoxUploadImageSlider"
                                    >
                                        <div className="d-flex align-items-center position-relative w-100 mx-3">
                                            <Dropzone onDrop={((acceptedFiles) => {
                                                onDrop(acceptedFiles, data.id)
                                            })}>
                                                {({getRootProps, getInputProps}) => (
                                                    <div {...getRootProps()}>
                                                        <input {...getInputProps()} />
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="d-flex parentIconUploadBox">
                                                                <h3>انتخاب فایل</h3>
                                                            </div>
                                                            <div
                                                                className="parentImagePreview"
                                                            >
                                                                {res.value !== "" &&
                                                                Determination(res.value)
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        </div>
                                    </Grid>
                                    :
                                    <Grid item key={i}
                                          lg={4} xl={4}
                                          className="d-flex justify-content-center align-items-start "
                                    >
                                        <div className="d-flex align-items-center position-relative w-100 m-3"
                                             key={i}>
                                            <div
                                                className={`divParentInputUnitInput w-100 parentInputCreateSlider`}
                                            >
                                                <TextField
                                                    key={i}
                                                    label={res.label}
                                                    variant="outlined"
                                                    name={res.name}
                                                    value={res.value}
                                                    className="w-100"
                                                    onChange={(e) => setParameters(e, data.id)}
                                                />
                                                {/*<input*/}
                                                {/*    type="text"*/}
                                                {/*    // onFocus={() => setParametersStaticFocused(data.name, true)}*/}
                                                {/*    // onBlur={() => setParametersStaticFocused(data.name, false)}*/}
                                                {/*    placeholder={res.label}*/}
                                                {/*    name={res.name}*/}
                                                {/*    value={res.value}*/}
                                                {/*    onChange={(e) => setParameters(e, data.id)}*/}
                                                {/*/>*/}
                                                {/*<label*/}
                                                {/*    className={`placeHolder ${res.value !== "" ? `placeHolderTop` : `placeHolderCenter`}`}*/}
                                                {/*>{res.label}*/}
                                                {/*</label>*/}
                                            </div>
                                        </div>
                                    </Grid>
                            ))}
                            <h3
                                className="deleteSlide"
                                onClick={() => {
                                    setIdSliderForDelete({id: data.id, store: data.store});
                                    // setDialogForDelete(true)
                                    removeProduct(data.id, data.store)
                                }}
                            >حذف اسلاید</h3>
                        </div>
                        {!data.store ?
                            <Button
                                variant="contained"
                                className="continuationButtonCreateProduct mr-3 mt-3 w-max"
                                onClick={() => registerSlider(data.id)}
                            >
                                ثبت
                            </Button>
                            :
                            <Button
                                variant="contained"
                                className="continuationButtonCreateProduct mr-3 mt-3 w-max"
                                onClick={() => EditSlider(data.id)}
                            >
                                ویرایش
                            </Button>
                        }
                    </div>
                })}

                <div
                    className="my-3 mr-4"
                    style={{borderTop: "1px solid rgba(0,0,0,0.3)"}}
                >
                    <Button
                        className="changeTypeButtonCreateProduct mt-3"
                        onClick={() => addSlider(sliders.length)}
                    >
                        ایجاد اسلایدر جدید
                    </Button>
                </div>
            </Paper>

        </Grid>
    );
}
